import { useInfoContext } from "../../../../contexts/InfoContext";
import { getTranslation } from "../../../../services/translation";

import { useConfigContext } from "../../../../contexts/ConfigContext"; 
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; 

const Careers = () => {
  const { careers } = useInfoContext();
  const { lang } = useConfigContext();
  const { t } = useTranslation();

  const mappedCards = careers.map(career => (
    <Link className="p-4 relative bg-cover bg-center cursor-pointer
      bg-slate-400 shrink-0 w-[300px] h-[300px] rounded shadow-sm
      hover:scale-105"
      style={{backgroundImage: `url(${career.image})`}}
      to={`/career/${career.uri}`}
      key={`card_${career.code}`}>
      
      <div className="absolute inset-0 bg-backdrop flex justify-center items-center">
        <hr className="absolute top-[50%] rotate-45 w-full text-white m-0"/>
        <hr className="absolute top-[50%] rotate-[-45deg] w-full text-white m-0"/>

        <h3 className="text-center text-white m-0">
          { getTranslation(career, "name", lang) }
        </h3>
      </div>

    </Link>
  ));

  return (
    <section className="flex-col items-center gap-4 bg-cover bg-no-repeat bg-center bg-conia-light">
      <h2 className="p-2 border-black" style={{ borderBottom: 1, borderStyle: "solid" }}>
        { t("index_conferences_text") }
      </h2>
      <div className="flex justify-center flex-wrap gap-4">
        { mappedCards }
      </div>
    </section>
  );
}

export default Careers;